import equineUpdatedEvent from '../images/events/EquineUpdatedEvent.jpg';
import familyFunDay from '../images/events/FunDay2026.jpg';
import mensDayImg from '../images/events/Mens_day_flyer_26.jpg';
import namilansingImg from '../images/homepagePics/NAMILansingPositiveSomebody.png';
import golfOutingImg from '../images/homepagePics/GolfOutingFlyer.png';

// PDF flyers, for the "Open PDF" button on the homepage flyer row
import golfOutingPdf from '../images/homepagePics/CACCU2026GolfOutingFlyer.pdf';
import namiLansingPdf from '../images/homepagePics/namiLansing.pdf';

// --- EVENT CONFIGURATION ---
// Single source of truth for both /events and the homepage. Each event's date
// determines whether it renders as Upcoming or Past automatically - nothing
// needs pruning by hand when an event passes.
//
// Optional fields, for an upcoming event that needs extra attention:
//   featured   - true gives the row the orange spotlight ring, a countdown
//                pill and a "Tickets On Sale Now" badge. Ignored once the
//                event is in the past. Only flag one event at a time.
//   ticketUrl  - external ticketing link; turns the CTA into a Get Tickets
//                button with "Become a Sponsor" demoted underneath it.
//   ticketNote - small print under the ticket button (price, age limit...).
//   pdfUrl     - downloadable flyer; becomes an "Open PDF" button on the
//                homepage when the event has no ticketUrl.
export const events = [
    {
        id: "golf-scramble",
        title: "38th Annual Charity Golf Scramble",
        date: new Date("2026-09-30T08:00:00"),
        displayDate: "September 30, 2026",
        displayTime: "Wednesday 8am",
        location: "Eldorado Golf Course",
        city: "Mason, MI",
        description: "Special collaborative event, hosted by Capital Area Chapter Credit Union for the benefit of Positive somebody",
        image: golfOutingImg,
        imageAlt: "Charity Golf Scramble",
        pdfUrl: golfOutingPdf,
    },
    {
        id: "halloween-bash",
        title: "Positive Somebody's Halloween Benefit Bash",
        date: new Date("2026-10-24T18:30:00"),
        displayDate: "Saturday, October 24, 2026",
        displayTime: "6:30 pm - 10:00 pm",
        location: "The Reo Town Marketplace",
        city: "1027 S. Washington Ave., Lansing, MI 48910",
        description: "Help children navigate the scary parts of life! Costume contest, dinner buffet, signature drinks, games, music and entertainment from DJ Metro Melik, silent auction, raffles, and more.",
        // Served from public/ with a stable name, so swapping the flyer is
        // a file overwrite - no content hash to change, nothing to 404.
        image: "/flyers/halloween_bash.png",
        imageAlt: "Positive Somebody's Halloween Benefit Bash flyer",
        featured: true,
        ticketUrl: "https://givebutter.com/halloween-bash-msz56v",
        ticketNote: "Tickets $35–$60 · Sponsorship $500 · 18 years or older unless otherwise reviewed",
    },
    {
        id: "international-mens-day",
        title: "International Men's Day",
        // Doors open 5:30pm, so the card stays Upcoming through the evening.
        date: new Date("2026-11-19T17:30:00"),
        displayDate: "Thursday, November 19, 2026",
        displayTime: "Doors 5:30 pm · Program begins 7:00 pm",
        location: "Lansing Shuffle",
        city: "325 Riverfront Dr, Lansing, MI 48912",
        description: "A community conversation about men's mental health, hosted with NAMI and Lansing Shuffle. Networking and resource fair, multiple chances to win a prize, complimentary soda, water and snacks, and complimentary shuffleboard passes until 10:00 pm. Come as you are.",
        image: mensDayImg,
        imageAlt: "International Men's Day flyer",
    },
    {
        id: "mental-wellness-workshop",
        title: "Mental Wellness Workshop",
        date: new Date("2026-08-29T10:00:00"),
        displayDate: "August 29th",
        displayTime: "10:00 am - 12:30 pm",
        location: "Child and Family Charities Non-Profit Hub",
        city: "",
        description: "Special collaborative event, hosted by NAMI and Positive somebody.",
        image: namilansingImg,
        imageAlt: "Mental Wellness Workshop",
        pdfUrl: namiLansingPdf,
    },
    {
        id: "equine-learning-center",
        title: "Learning to Cope and Heal With Positive Somebody & The Equine Learning Center",
        date: new Date("2026-05-30T11:00:00"),
        displayDate: "May 30th",
        displayTime: "11am-2pm",
        location: "The Equine Center For Learning",
        city: "",
        description: "Special collaborative event, hosted by Positive somebody and The Equine Learning Center.",
        image: equineUpdatedEvent,
        imageAlt: "Learning to Cope and Heal - Equine Event",
    },
    {
        id: "family-fun-day",
        title: "5th Annual Family Mental Health Fun Day",
        date: new Date("2026-06-20T11:00:00"),
        displayDate: "June 20th",
        displayTime: "11am-3pm",
        location: "Potter Park Zoo",
        city: "",
        description: "Our free fun, festival-style day filled with hands-on mental health activities, community resources, and fun for all ages.",
        image: familyFunDay,
        imageAlt: "Family Mental Health Fun Day",
    },
];

// Split events against today's date. A function, not a constant, so "now" is
// evaluated at render rather than frozen when the module first loads.
export const splitEvents = () => {
    const now = new Date();
    return {
        now,
        upcoming: events.filter((e) => e.date >= now).sort((a, b) => a.date - b.date),
        past: events.filter((e) => e.date < now).sort((a, b) => b.date - a.date),
    };
};

// Calendar days from today until an event, as a short label. Null once past.
// Compares midnights so an event later today reads "Today", not "Tomorrow".
export const countdownLabel = (date, now = new Date()) => {
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const eventDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const days = Math.round((eventDay - today) / 86400000);
    if (days < 0) return null;
    if (days === 0) return "Today";
    if (days === 1) return "Tomorrow";
    return `${days} days away`;
};

// "October 24" - derived from the real date so homepage labels can't drift.
export const shortDate = (date) =>
    date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
